import { forwardRef } from "react";
import { tv } from "tailwind-variants";

import { CopyableText } from "./CopyableText";
import { EditableText } from "./EditableText";

import type { HTMLAttributes } from "react";
import type { VariantProps } from "tailwind-variants";
import type { ForwardRefComponentWithSubcomponents } from "../../utils/types";

export const textVariants = tv({
  base: "text-base",
  variants: {
    size: {
      sm: "text-xs",
      md: "text-sm",
      lg: "text-base",
    },
    bold: {
      true: "font-semibold",
      false: "font-normal",
    },
    emphasis: {
      default: "text-primary",
      secondary: "text-secondary",
      tertiary: "text-tertiary",
    },
  },
  defaultVariants: {
    bold: false,
    size: "md",
    emphasis: "default",
  },
});

export interface TextProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof textVariants> {}

export const Text = forwardRef<HTMLSpanElement, TextProps>(
  ({ className, size, bold, emphasis, ...props }, ref) => {
    return (
      <span ref={ref} className={textVariants({ className, size, bold, emphasis })} {...props} />
    );
  }
) as ForwardRefComponentWithSubcomponents<
  HTMLSpanElement,
  {
    Editable: typeof EditableText;
    Copyable: typeof CopyableText;
  },
  TextProps
>;
Text.displayName = "Text";
Text.Editable = EditableText;
Text.Copyable = CopyableText;
